<template>
  <div>
      <router-link class="button" :to="{name: dest}" tag="button">{{dest}}</router-link>
  </div>
</template>
<script>
export default {
  name: 'Button',
  props: {
    dest: String
  }
}
</script>
